import { Inbox } from 'lucide-react';
import Button from './Button';

function EmptyState({ icon: Icon = Inbox, title = 'Sin resultados', description, actionLabel, onAction }) {
  return (
    <div className="flex flex-col items-center rounded-card border border-dashed bg-slate-50/60 px-6 py-10 text-center">
      <span className="grid size-11 place-items-center rounded-full bg-white text-content-muted shadow-xs">
        <Icon className="size-5" aria-hidden="true" />
      </span>
      <h3 className="mt-4 font-semibold text-content-primary">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-content-muted">{description}</p>}
      {actionLabel && <Button size="sm" className="mt-5" onClick={onAction}>{actionLabel}</Button>}
    </div>
  );
}

export default EmptyState;
